// extracted by mini-css-extract-plugin
export default {"userCollectionsMessage":"UserCollections_userCollectionsMessage__CBJYS"};